import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';
import axiosClient from '../../../../../../../../lib/axios';
import LoadingFechamento from '../../LoadingFechamento';

export default function DialogCancelarFechamento({ open, id, onClose, handleExcluido }: DialogCancelarFechamentoProps) {

    const queryClient = useQueryClient();

    const { mutate: excluirLancamentos, isLoading } = useMutation({
        mutationKey: 'cancelar-fechamento',
        mutationFn: () => axiosClient.post(`/financeiro/conta-corrente-consumo/cancelar-fechamento/${id}`),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar("Erro ao cancelar fechamento", { variant: "error" })
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar("Fechamento cancelado com sucesso", { variant: "success" })
            queryClient.invalidateQueries([`pesquisar-proximos-fechamentos`])
            queryClient.invalidateQueries([`pesquisar-ultimos-fechamentos`])
            handleExcluido()
        },
    });

    const handleExcluir = () => {
        excluirLancamentos();
    }

    return (
        <Dialog maxWidth='xs' fullWidth open={open}>
            <DialogTitle>Cancelar fechamento</DialogTitle>
            <DialogContent>
                {isLoading ? <LoadingFechamento id={id} label="Cancelando fechamento" /> : (
                    <DialogContentText>
                        Deseja realmente cancelar esse fechamento?
                    </DialogContentText>
                )}
            </DialogContent>
            {
                !isLoading && (
                    <DialogActions>
                        <Button variant="outlined" onClick={onClose}>Voltar</Button>
                        <Button
                            color='error'
                            variant="contained"
                            onClick={handleExcluir}
                        >
                            Cancelar
                        </Button>
                    </DialogActions>
                )
            }
        </Dialog>
    )
}

interface DialogCancelarFechamentoProps {
    open: boolean;
    id: number;
    onClose: () => void;
    handleExcluido: () => void;
}
